module.exports = __webpack_public_path__ + "static/media/contacts.4cba1bde.svg";